import React from 'react';
import StatusPage from './StatusPage';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV !== 'test') {
      // Keep production users on a useful screen while preserving diagnostics for developers.
      console.error('Application error boundary caught an error:', error, errorInfo);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  handleReset = () => {
    this.setState({ error: null });
  };

  render() {
    if (this.state.error) {
      // Non-essential widgets pass their own fallback (often null) so a crash
      // in them never replaces the whole page with the error screen.
      if (this.props.fallback !== undefined) {
        return this.props.fallback;
      }
      return (
        <StatusPage
          statusCode="Error"
          eyebrow="Something went wrong"
          title="This page could not be loaded."
          message={
            'Try refreshing the page. If it keeps happening, return to the dashboard and try the workflow again.'
          }
          primaryAction={{ label: 'Refresh page', onClick: () => window.location.reload() }}
          secondaryAction={{ label: 'Go to dashboard', to: '/' }}
          details={process.env.NODE_ENV === 'development' ? this.state.error.message : undefined}
          onReset={this.handleReset}
        />
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
